import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import RegisterForm from '@components/RegisterForm'
import { requestRegister, getUserByEmail, requestLogin } from '@actions/user'

import V2Layout from '../V2Layout'
import V2Stepper from '../V2Stepper'
import V2CartAside from '../V2CartAside'
import '../../../css/v2.css'

// Cadastro de novo comprador no fluxo V2 (pedido de negócio 09/09, rodada 3, item 20).
// DECISÃO DE ARQUITETURA: o formulário V1 (RegisterForm, 37 regras I-*, IE/Sintegra,
// CEP/frete, termos e política com data de aceite) é reusado POR INTEIRO; o wrapper
// `v2-uuf v2-reg` aplica o design system por CSS. As props são as mesmas que o
// container V1 (Identification) injeta. No sucesso o próprio RegisterForm volta ao
// Resumo V2 pela flag `smd_v2_flow` (ponte já existente, spec 05).

export default function V2Cadastro() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector(state => state.user)

  sessionStorage.setItem('smd_v2_flow', '1')

  const submitRegisterForm = (data, isDefault) => Promise.resolve(dispatch(requestRegister(data, isDefault)))
  const _getUserByEmail = email => dispatch(getUserByEmail(email))
  const _requestLogin = (data, path) => dispatch(requestLogin(data, path))
  // swapTo(0) no V1 volta ao login; aqui volta à identificação V2
  const swapTo = () => navigate('/v2/steps/identificacao')

  return (
    <V2Layout>
      <V2Stepper current={2} />
      <div className="v2-step-grid" style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 32px 110px', display: 'grid', gridTemplateColumns: '1fr 340px', gap: '40px', alignItems: 'start' }}>
        <div className="v2-uuf v2-reg">
          <span className="v2-eyebrow">Etapa 3 de 5</span>
          <h1 style={{ margin: '8px 0 0', fontFamily: 'Poppins,sans-serif', fontWeight: '600', fontSize: '34px', lineHeight: '1.15', letterSpacing: '-0.7px', color: '#373535' }}>
            Criar conta
          </h1>
          <p style={{ margin: '12px 0 8px', maxWidth: '560px', fontSize: '16px', lineHeight: '1.6', color: '#6B6664' }}>
            Falta pouco. Preencha seus dados para continuar a compra.{' '}
            <button
              id="v2-register-back"
              type="button"
              onClick={swapTo}
              style={{ border: 'none', background: 'none', padding: 0, fontSize: '16px', fontWeight: '700', color: '#D8262C', cursor: 'pointer' }}
            >
              Já tenho conta
            </button>
          </p>
          <RegisterForm
            swapTo={swapTo}
            submitRegisterForm={submitRegisterForm}
            getUserByEmail={_getUserByEmail}
            requestLogin={_requestLogin}
            user={user}
            title="Cadastro"
            subtitle="Falta pouco. Faça seu cadastro para continuar."
          />
        </div>
        <V2CartAside />
      </div>
    </V2Layout>
  )
}
